import Snappy from "../../../libs/snappy/snappy";
import App from 'resizement/scripts/resize';

Snappy.Component.EduAlert = class EduAlert extends Snappy.BaseComponent {
    static get tagName() {
        return 'edu-alert';
    }

    constructor(element) {
        super(element);
    }

    render () {
        this.setVars();
        this.setEventListeners();
        if (!this.localStorage.eduAlert) {
            this.open();
        }

    }

    setEventListeners() {
        this.$window.on('eduAlert:close', this.close.bind(this));

        this.closeBtn.addEventListener('click', this.closeHandle.bind(this));

        this.ctaBtn.addEventListener('click', this.ctaClickHandle.bind(this));
    }

    setVars() {
        this.localStorage = window.localStorage;
        this.element = this.$element[0];
        this.closeBtn = this.element.querySelector('.js-edu-alert__close');
        this.ctaBtn = this.element.querySelector('.js-edu-alert__cta');
        this.open = this.open.bind(this);
        this.close = this.close.bind(this);
    }

    closeHandle() {
        this.$window.trigger('eduAlert:close'); // close all instances
    }


    open() {
        this.element.classList.remove('is-closed');
        this.localStorage.setItem('eduAlert', 'true');
    }

    close() {
        this.element.classList.add('is-closed');
    }

    removeFromStorage() {
        this.localStorage.removeItem('eduAlert');
    }

    ctaClickHandle() {
        this.$window.trigger('profileDisclaimer:open');
        this.$window.trigger('eduAlert:close');
    }
};



// WEBPACK FOOTER //
// ./components/edu-alert/scripts/edu-alert.js